import { render, staticRenderFns } from "./BasePercent.vue?vue&type=template&id=2ba94283&scoped=true&"
import script from "./BasePercent.vue?vue&type=script&lang=ts&"
export * from "./BasePercent.vue?vue&type=script&lang=ts&"
import style0 from "./BasePercent.vue?vue&type=style&index=0&id=2ba94283&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba94283",
  null
  
)

export default component.exports